import { useParams } from '@tanstack/react-router'
import { useTranslation } from '@kostbar/i18n'
import { RestaurantVivaForm } from '../components/restaurant-viva-form'
import {
  useRemoveRestaurantVivaConfig,
  useRestaurantVivaConfig,
  useSaveRestaurantVivaConfig,
} from '../hooks/use-restaurant-viva-config'
import { useAuth } from '@/features/auth/hooks/use-auth'
import { ROLES } from '@/shared/constants/roles'

/**
 * Payment-provider settings per restaurant (CHG-2026-08-viva-isv). SUPER_ADMIN only, mirroring
 * the backend rule: the ISV fee is webbill's commercial term and the merchant id determines
 * where the money lands, so tenant staff must not see or edit it.
 */
export function RestaurantPaymentsPage() {
  const { t } = useTranslation('restaurants')
  const { id } = useParams({ strict: false })
  const restaurantId = Number(id)
  const { hasRole } = useAuth()

  const { data, isLoading } = useRestaurantVivaConfig(restaurantId)
  const save = useSaveRestaurantVivaConfig(restaurantId)
  const remove = useRemoveRestaurantVivaConfig(restaurantId)

  if (!hasRole(ROLES.SUPER_ADMIN)) {
    return (
      <div className="text-muted-foreground py-12 text-center">
        {t('viva.forbidden')}
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">{t('viva.title')}</h1>
        <p className="text-muted-foreground mt-1">{t('viva.subtitle')}</p>
      </div>

      {!isLoading && (
        <RestaurantVivaForm
          config={data}
          onSave={(body) => save.mutate(body)}
          onRemove={() => remove.mutate()}
          saving={save.isPending}
          removing={remove.isPending}
        />
      )}
    </div>
  )
}
